









import {
  Component,
  Emit,
  Model,
  Prop,
  Vue,
  Watch
} from "vue-property-decorator";
import VipContent from "./VipContent.vue";
import VipHeader from "./VipHeader.vue";
import NotVipHeader from "./NotVipHeader.vue";
import NotVipBottom from "./NotVipBottom.vue";
import { isVip } from "@/utils/general_utils";
@Component({
  components: { VipContent, VipHeader, NotVipHeader, NotVipBottom }
})
export default class VipIntrodution extends Vue {
  private isVip = false;

  private getIsVip() {
    this.isVip = isVip();
  }

  private mounted() {
    this.getIsVip();
  }
  private activated() {
    this.getIsVip();
  }
}
